import React, { useEffect, useState } from 'react'
import useFetch from 'use-http'

import { Box, Button, Card, Heading, Inline, Modal, Stack, TextField } from '@myxplor/stardust'

interface Props {
  isOpen: boolean
  service: Papi.Service
  onCancel(): void
  onSave(): void
}

const ContactEmailModal = ({ isOpen, service, onCancel, onSave }: Props) => {
  const [emailModel, setEmailModel] = useState<Nullable<Record<string, any>>>()

  const emailRequest = useFetch(`/api/v1/services/${service.id}`)

  const onChange = (field: string, value: number | string) => {
    setEmailModel((model: any) => ({ ...model, [field]: value }))
  }

  const handleSave = async () => {
    if (emailModel) {
      await emailRequest.patch(emailModel)

      onSave()
    }
  }

  useEffect(() => setEmailModel({}), [isOpen])

  if (!emailModel) {
    return null
  }

  const isValid = !!emailModel.contact_email

  return (
    <Modal backdrop isOpen={isOpen} onBlur={onCancel}>
      <Card>
        <Box minWidth={600} padding="small">
          <Stack space="small">
            <Heading level={5}>Contact Email</Heading>
            <TextField
              label="Contact Email"
              name="contact_email"
              placeholder="Contact email address to send onboarding emails to"
              required
              value={emailModel.contact_email || ''}
              onChange={(value) => onChange('contact_email', value)}
            />
            <Inline align="right" space="small">
              <Button variant="outline" onClick={onCancel}>
                Cancel
              </Button>
              <Button disabled={!isValid} onClick={handleSave}>
                Save
              </Button>
            </Inline>
          </Stack>
        </Box>
      </Card>
    </Modal>
  )
}

export default React.memo(ContactEmailModal)
